import React from "react";
import WeatherWidget from "./widget/WeatherWidget";

const App = () => {
  return (
    <div>
      <WeatherWidget />
    </div>
  );
};

export default App;
